/** */
import {
  ADD_SEARCH_RESULTS_TO_STORE,
  ADD_MANY_REFERRALS_TO_STORE,
  ADD_ONE_REFERRAL_TO_STORE,
  REMOVE_MANY_REFERRALS_FROM_STORE,
  REMOVE_ONE_REFERRAL_FROM_STORE,
  LOAD_REFERRALS_TO_STORE
} from '../actions/referrals';

export default (state = {}, action) => {
  const { type, payload } = action;
  const current_state = state;
  switch (type) {
    case ADD_MANY_REFERRALS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (tutorials, tutorial) => ({
            ...tutorials,
            [tutorial.id]: tutorial
          }),
          {}
        )
      };
    case ADD_ONE_REFERRAL_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (tutorials, tutorial) => ({
            ...tutorials,
            [tutorial.id]: tutorial
          }),
          {}
        )
      };
    case LOAD_REFERRALS_TO_STORE:
      return {
        ...payload.reduce(
          (tutorials, tutorial) => ({
            ...tutorials,
            [tutorial.id]: tutorial
          }),
          {}
        )
      };
    case REMOVE_MANY_REFERRALS_FROM_STORE:
      payload.forEach((id) => delete current_state[id]);
      return {
        ...current_state
      };
    case REMOVE_ONE_REFERRAL_FROM_STORE:
      delete current_state[payload];
      return { ...current_state };
    default:
      return state;
  }
};
